import analiticaInstance from '@/vendor/analitica.vendor'

/**
 * @typedef {import('@stone-payments/analitica').EventFactory} EventFactory
 * @description This is the event that will be sent to the Amplitude plugin
 * @description import Amplitude from '@amplitude/sidemenu.amplitude'
 * @example Amplitude.events.menu.submenu.buttonClicked()
 * @description
 * @example context: { subcontext: {} }
 */

const sideMenuEvents = analiticaInstance.eventFactory('Sidemenu', {
  home: {
    buttonClicked: () => ({ label: 'sidemenu - resume button clicked' })
  },
  sales: {
    buttonClicked: ({ submenu }) => ({
      label: `sidemenu - sales ${submenu} button clicked`
    })
  },
  financial: {
    buttonClicked: ({ submenu }) => ({
      label: `sidemenu - financial ${submenu} button clicked`
    })
  },
  recurrence: {
    buttonClicked: ({ submenu }) => ({
      label: `sidemenu - recurrence ${submenu} button clicked`
    })
  },
  recipients: {
    buttonClicked: () => ({ label: 'sidemenu - recipients button clicked' })
  },
  customers: {
    buttonClicked: () => ({ label: 'sidemenu - customers button clicked' })
  },
  webhooks: {
    buttonClicked: () => ({ label: 'sidemenu - webhooks button clicked' })
  },
  team: {
    buttonClicked: ({ submenu }) => ({
      label: `sidemenu - team ${submenu} button clicked`
    })
  },
  settings: {
    buttonClicked: ({ submenu }) => ({
      label: `sidemenu - ${submenu} settings button clicked`
    })
  },
  physicalWorld: {
    buttonClicked: ({ submenu }) => ({
      label: `sidemenu - physical world ${submenu} button clicked`
    })
  },
  quickLinks: {
    hubButtonClicked: () => ({
      label: 'sidemenu - quick links hub button clicked'
    }),
    shopButtonClicked: () => ({
      label: 'sidemenu - quick links shop button clicked'
    }),
    helpCenterButtonClicked: () => ({
      label: 'sidemenu - quick links help center button clicked'
    }),
    simulatorButtonClicked: () => ({
      label: 'sidemenu - quick links simulator button clicked'
    })
  }
})

export default sideMenuEvents
